define('views/pages/user/details',['require','underscore','mediator','lib/utils','views/base/form','text!templates/pages/user/details.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var _ = require('underscore'),
        mediator = require('mediator'),
        utils = require('lib/utils'),
        FormView = require('views/base/form'),
        template = require('text!templates/pages/user/details.ejs'),
        DemoDialog = require('views/demo-dialog');

    // USER DETAILS

    var UserDetailsPageView = FormView.extend({
        autoRender: true,
        template: template,
        customValidation: true,
        className: 'page',
        id: 'pages-user-details-page',
        region: 'main',
        listen: {
            'change:loading model': 'updateBreadcrumb'
        },
        initialize: function() {
            FormView.prototype.initialize.apply(this, arguments);
            var _this = this;
            this.model.on('afterLoad', function() {
                _this.render();
            });
        },
        save: function(){

            if (DemoDialog.isDemo()) { return this.render() && DemoDialog.show(); }

            var _this = this,
            fio = this.model.get('FIO'), _contactEmail = this.model.get('_contactEmail');

            var errors = {};
            if(!fio){
                errors.FIO = 'Поле "Ф.И.О." не должно быть пустым';
            } else {
                if(fio.length > 100){ errors.FIO = 'Содержимое поля "Ф.И.О." слишком большое'; }
            }

            if(_contactEmail && !utils.isEmail(_contactEmail)){
                errors._contactEmail = 'Неправильный формат';
            }

            if(_.isEmpty(errors)){
                if(this.model.get('ID') !== 0 ){
                    this.model.save().complete(function(response) {
                        var messages = response.responseJSON.messages;
                        if(messages){
                            if (messages.global) {
                                _this.errorMessages = [];
                                _this.errorMessages.push('Ошибка при сохранении');
                            } else {
                                _this.model.set('errors', messages);
                            }
                        } else {
                            _this.errorMessages = [];
                            _this.model.set('errors', {});
                        }
                       _this.render();
                    });
                }
            } else {
                this.model.set('errors', errors);
                this.render();
            }
        },
        updateBreadcrumb: function() {
            var org = {
                name: 'organization',
                action: 'organization#show',
                params: { page: 'settings'},
                title: 'Компания'
            },
            orgUsers = {
                name: 'organization',
                action: 'organization#show',
                params: { page: 'users'},
                title: 'Сотрудники'
            };
            mediator.setBreadcrumb([org, orgUsers, 'user'], 'Контактная информация');
        }
    });

    return UserDetailsPageView;
});
